/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { useTheme } from 'emotion-theming';
import IcomoonReact from 'icomoon-react';

import { useDispatch } from 'react-redux';
import iconSet from '../../../shared/images/teambuildr-selection.json';
import Text from '../../../shared/components/Text/Text';

const ModalContainer = styled('div')`
  .remove-div {
    width: 100%;
    display: flex;
    justify-content: space-between;
    background: ${({ theme }) => theme.colors.surfaceElevated};
    z-index: 1001;
    .remove-div-icon {
      cursor: pointer;
    }
  }
  height: 100%;
  position: relative;
  padding-bottom: 80px;
`;

const ModalTextTop = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 24px;
  font-weight: 700;
`;

const SelectProgramModal = ({
  closeModal,
}) => {
  const { colors } = useTheme();
  const dispatch = useDispatch();

  return (
    <ModalContainer>
      <div className='remove-div'>
        <div style={{
          display: 'flex',
          alignItems: 'center',
        }}
        >
          <ModalTextTop>Select Program</ModalTextTop>
        </div>
        <div
          className='remove-div-icon'
          onClick={() => closeModal()}
        >
          <IcomoonReact
            iconSet={iconSet}
            size={15}
            icon='remove'
            color={colors.textSecondary}
          />
        </div>
      </div>
      <Text>this is where the programs will go</Text>
    </ModalContainer>
  );
};

SelectProgramModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

export default SelectProgramModal;
